import { render, staticRenderFns } from "./TickPicturePdf.vue?vue&type=template&id=22c128d0&scoped=true&"
import script from "./TickPicturePdf.vue?vue&type=script&lang=js&"
export * from "./TickPicturePdf.vue?vue&type=script&lang=js&"
import style0 from "./TickPicturePdf.vue?vue&type=style&index=0&id=22c128d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c128d0",
  null
  
)

export default component.exports